var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRetangleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 7,
    viewBox: "0 0 36 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0049 0.97998H3.00488C1.34803 0.97998 0.00488281 2.32313 0.00488281 3.97998C0.00488281 5.63683 1.34803 6.97998 3.00488 6.97998H32.0049C33.6617 6.97998 35.0049 5.63683 35.0049 3.97998C35.0049 2.32313 33.6617 0.97998 32.0049 0.97998Z",
    fill: "#0033AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRetangleBlue);
export default __webpack_public_path__ + "static/media/ic_retangle_blue.856991677bd6da30ccc37b29bd046280.svg";
export { ForwardRef as ReactComponent };